import { Page, Spinner } from '@cint/wonderment';
import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { useFetchData } from '@/api/apiHooks';
import { ResourceNotFound } from '@/components/ResourceNotFound';
import { PanelsResponsePanel } from '@/utils/types';
import { URLS } from '@/utils/urls';

interface ValidatedPanelRouteProps {
  children: ReactNode;
}

export const ValidatedPanelRoute = ({ children }: ValidatedPanelRouteProps) => {
  const { id: panelId, companyId: urlCompanyId } = useParams();

  const {
    data: panelDetail,
    isLoading,
    isFetching,
    error,
  } = useFetchData<PanelsResponsePanel>({
    url: URLS.getPanel(panelId),
    enabled: !!panelId,
    keepPreviousData: false,
    staleTime: 30 * 1000,
  });

  if (!panelId) {
    return <ResourceNotFound />;
  }

  if (isLoading) {
    return (
      <Page
        style={{
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spinner size="xl" />
      </Page>
    );
  }

  if (error?.response?.status === 404 || (!isLoading && !panelDetail)) {
    return <ResourceNotFound />;
  }

  if (
    !isFetching &&
    urlCompanyId &&
    panelDetail?.company_id &&
    urlCompanyId !== panelDetail.company_id
  ) {
    return <ResourceNotFound />;
  }

  return <>{children}</>;
};
